document.addEventListener('DOMContentLoaded', function () {
  var namePanel = document.querySelector('[data-ahm-panel="name"]');
  var logoPanel = document.querySelector('[data-ahm-panel="logo"]');
  if (!namePanel && !logoPanel) return;

  function brandingValue() {
    var checked = document.querySelector('input[name="Branding"]:checked');
    return checked ? checked.value : '';
  }

  function isCustomLogo() {
    return /logo/i.test(brandingValue());
  }

  function setDisabled(root, disabled) {
    if (!root) return;
    root.querySelectorAll('input, textarea, select, button').forEach(function (el) {
      if (el.type === 'hidden' || el.getAttribute('data-ahm-keep') === 'true') {
        el.disabled = disabled;
        return;
      }
      if (el.type === 'file' || el.type === 'button') return;
      el.disabled = disabled;
    });
  }

  function sync() {
    var logo = isCustomLogo();
    if (namePanel) {
      namePanel.hidden = logo;
      setDisabled(namePanel, logo);
    }
    if (logoPanel) {
      logoPanel.hidden = !logo;
      setDisabled(logoPanel, !logo);
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'Branding') sync();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, sync);
  }

  sync();
});
